import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-oo-pages',
  templateUrl: './oo-pages.component.html',
  styleUrls: ['./oo-pages.component.scss']
})
export class OoPagesComponent implements OnInit {
  isFranchisee:boolean=false;
  constructor(private commonService:CommonService) { }

  ngOnInit(): void {
    this.isFranchisee=this.commonService?.isFranchisee;
  }

}
